// Login action types ------>
export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const EMPLOYER_LOGIN_SUCCESS = "EMPLOYER_LOGIN_SUCCESS"
// Register action types ------>

export const REGISTER_REQUEST = "REGISTER_REQUEST"
export const REGISTER_FAILURE = "REGISTER_FAILURE"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"

export const EMPLOYER_REGISTER_SUCCESS = "EMPLOYER_REGISTER_SUCCESS"
// Logout action types ------>

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"